var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"body-2"},[_c('v-icon',{attrs:{"dense":"","color":_vm.color}},[_vm._v(_vm._s(_vm.icon))]),_vm._v(" "+_vm._s(_vm.text))],1)}
var staticRenderFns = []

export { render, staticRenderFns }